import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeepLinkingService } from '@core/services/deep-linking.service';
import { SpinnerService } from '@core/services/spinner.service';
import { AuthBehaviors } from '@core/services/token/token-behaviors';
import { TokenStorageService } from '@core/services/token/token-storage.service';
import { TokenService } from '@core/services/token/token.service';
import { TokenResponse } from '@core/typings/token.typing';
import { ClientUserService } from '@features/client-user/client-user.service';
import { ImpersonationService } from '../impersonation.service';
import { LoginMethod } from '@core/typings/login-method.typing';

@Component({
  selector: 'gc-impersonation-landing-page',
  templateUrl: './impersonation-landing-page.component.html',
  styleUrls: ['./impersonation-landing-page.component.scss']
})
export class ImpersonationLandingPageComponent implements OnInit {

  constructor (
    private tokenService: TokenService,
    private activatedRoute: ActivatedRoute,
    private clientUserService: ClientUserService,
    private spinnerService: SpinnerService,
    private deepLinkingService: DeepLinkingService,
    private behavior: AuthBehaviors,
    private impersonationService: ImpersonationService,
    private tokenStorageService: TokenStorageService
  ) { }

  async ngOnInit () {
    this.spinnerService.startSpinner();
    if (!this.tokenService.getIsLoggedIn()) {
      if (this.tokenService.isBbid) {
        this.tokenStorageService.revoke();
        await this.handleImpersonation();
      } else {
        await this.handleImpersonation();
      }
    } else {
      if (this.tokenService.isBbid) {
        this.tokenStorageService.revoke();
        await this.handleImpersonation();
      } else {
        await this.impersonationService.logoutExistingUserBeforeImpersonation();
        setTimeout(async () => {
          await this.handleImpersonation();
        }, 750);
      }
    }
    this.spinnerService.stopSpinner();
  }

  async handleImpersonation () {
    const queryParams = this.activatedRoute.snapshot.queryParams as {
      response: string;
      clientIdentifier: string;
      clientId: string;
    };
    const tokenResponse: TokenResponse = JSON.parse(atob(queryParams.response));
    tokenResponse.clientId = +queryParams.clientId;
    this.tokenService.tokenSignin(tokenResponse);
    const jwt = this.tokenService.parseJwt(tokenResponse.token);
    this.tokenService.trackInitialLoginData(
      LoginMethod.Impersonate, 
      true, 
      jwt?.UserId, 
      jwt?.email, 
      Number(jwt?.client_id));
    this.tokenStorageService.overrideClientIdentifier(queryParams.clientIdentifier);
    this.impersonationService.setImpersonationSessionId();
    await this.clientUserService.getUser(true);
    this.deepLinkingService.attemptDeepLink(this.behavior.current.postLoginRedirect);
  }
}
